import React from 'react';

import IconSelector from '@ibibo/icon-selector';
import {defaultTheme} from '@ibibo/build-theme';

import * as S from './MyBookingsUI.styles';

import TripBookingCard from './TripBookingCard/TripBookingCard';
import NoBookingCard from '../../../../../../../myaccount/src/stories/components/myTripsListing/ListingBody/NoBookingCard/NoBookingCard';
// import TripHeader from './TripHeader/TripHeader';

const MyBookingsUI = ({bookingDetails, activeTab, navigateToMyTripsDetails, headers, updateActiveTab}) => {
  const navigateToMyTrips = () => {
    window.open('/mytrips/', '_self');
  }

  let count = 0;

  return(
    <S.MyBookingMainWrap>
      <S.MyBookingsHeaderWrap>
        <S.MyBookingsHeadText>Your Bookings</S.MyBookingsHeadText>
        <S.ViewAllBookingsText onClick={navigateToMyTrips}>
          View All
          <IconSelector iconKey="rightarrow" props={{width: '1rem', height: '1rem', fill: defaultTheme.colors.blue.base, margin: `${defaultTheme.spacing.nospacing} ${defaultTheme.spacing.base}`}} />
        </S.ViewAllBookingsText>
      </S.MyBookingsHeaderWrap>
      {/* <TripHeader headers={headers} updateActiveTab={updateActiveTab} activeTab={activeTab}/> */}
      <S.MyBookingsOuterWrap>
        {bookingDetails.filter(item =>{
          return (item.trip_type.toLowerCase() === 'upcoming');
        }).map((bookingDetail, i) => {
          count++;
          if (i >= 7) {
            return null;
          }
          return (<TripBookingCard key={`bookingCard${i}`} bookingDetail={bookingDetail} navigateToMyTripsDetails={navigateToMyTripsDetails} />);
        })}
        {count === 0 && <NoBookingCard showButton={false} tab={activeTab} navigateToHotels={() => {}} />}
      </S.MyBookingsOuterWrap>
      <S.MyBookingsFooterWrap>
        <S.MyBookingsHeadText></S.MyBookingsHeadText>
        <S.ViewAllBookingsText onClick={navigateToMyTrips}>
          View All
          <IconSelector iconKey="rightarrow" props={{width: '1rem', height: '1rem', fill: defaultTheme.colors.blue.base, margin: `${defaultTheme.spacing.nospacing} ${defaultTheme.spacing.base}`}} />
        </S.ViewAllBookingsText>
      </S.MyBookingsFooterWrap>
    </S.MyBookingMainWrap>
  );
}

export default MyBookingsUI;